<template>
    <div class="CardLayout">
        <slot v-if="!isLoading"></slot>
        <template v-else>
            <BaseCard
                v-for="c in cardCount"
                :key="c"
                status="loading"
            />
        </template>
    </div>
</template>
<script>
import stat from 'status';
import BaseCard from 'components/Complex/Cards/RPBaseCard.vue';

export default {
    name: 'RPCardsLayout',
    components: {
        BaseCard,
    },
    props: {
        /**
        * A status pulled from the common `status` constants (`/src/status/index.js`)
        */
        status: {
            type: String,
            default: stat.STANDBY,
        },
    },
    computed: {
        isLoading() {
            return this.status === stat.LOADING;
        },
        cardCount(){
            if(this.$slots.default){
                return this.$slots.default.filter(s => s.tag).length;
            }
            return 0;
        },
    },
};
</script>
<style lang="scss">
    .CardLayout {
        display: flex;
        flex-direction: column;
    }
</style>

<docs>
    Displays cards in flex column with consistent spacing.  May provide more utility in the future.
    ```[import](./examples/RPCardsLayoutExample.vue)
    ```
</docs>
